import logo from './smrtm.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://smartium.io"
          target="_blank"
          rel="noopener noreferrer"
        >
          SMARTIUM labs
        </a>
      </header>
    </div>
  );
}

export default App;
